import {
  initialState,
  Actions,
  State,
  EDIT_SUPPORT_TASK,
  EDIT_SUPPORT_TASK_SUCCESS,
  EDIT_SUPPORT_TASK_ERROR,
  RESET_EDIT_SUPPORT_TASK,
} from '../../types/support-tasks/edit'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_SUPPORT_TASK:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_SUPPORT_TASK_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_SUPPORT_TASK_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_SUPPORT_TASK:
      return initialState
    default:
      return state
  }
}

export default reducers
